(function(){
'use strict';
if(window.__rsCartUXv3)return;
window.__rsCartUXv3=true;
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
root=String(root);if(root.slice(-1)!=='/')root+='/';
var timer=0,request=null,notice=null;
// REALSTIL 2026-10-29: cart drawer + cart page render their progress unit server-side
// (snippets/rs-cart-progress) and the section merge keeps it current, so /cart.js is
// only fetched if a legacy .free-shipping-bar is still on the page.
var BAR_SELECTOR='.free-shipping-bar[data-free-shipping-amount]';
function getCart(){
 if(request)return request;
 request=fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
 .then(function(r){if(!r.ok)throw Error('cart');return r.json();})
 .finally(function(){request=null;});
 return request;
}
function money(cents,currency){
 try{return new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:currency||'EUR'}).format(cents/100);}
 catch(e){return (cents/100).toFixed(2).replace('.',',')+' €';}
}
function syncBars(cart){
 if(!cart||typeof cart.total_price!=='number')return;
 document.querySelectorAll(BAR_SELECTOR).forEach(function(bar){
  var limit=Number(bar.dataset.freeShippingAmount);
  if(!Number.isFinite(limit)||limit<=0)return;
  var sum=cart.total_price,progress=Math.min(1,Math.max(0,sum/limit)),met=progress>=1;
  bar.dataset.freeShippingProgress=met?'1':String(Math.round(progress*10000)/10000);
  bar.dataset.freeShippingCurrentCart=String(sum);
  bar.dataset.rsShippingState=met?'met':'under';
  bar.style.setProperty('--free-shipping-progress',String(progress));
  bar.style.setProperty('--free-shipping-bar-color',met?'#94CCA5':'#F59E0B');
  bar.classList.toggle('free-shipping-bar--no-cart',!cart.item_count);
  if(!met){
   var dest=bar.querySelector('.free-shipping-bar__message--no'),tpl=bar.dataset.rsShippingTemplate;
   if(dest&&tpl&&tpl.indexOf('__RS_AMOUNT__')>=0){
    dest.textContent=tpl.replace('__RS_AMOUNT__',money(Math.max(0,limit-sum),bar.dataset.rsShippingCurrency||cart.currency));
   }
  }
 });
}
function showNotice(){
 if(!notice)return;
 document.querySelectorAll('[data-rs-cart-discount]').forEach(function(box){
  box.dataset.rsState=notice.type;
  var p=box.querySelector('[data-rs-discount-status]');
  if(p)p.textContent=box.dataset['rs'+notice.key]||'';
  var input=box.querySelector('[data-rs-discount-input]');
  if(input&&notice.code&&!input.value)input.value=notice.code;
 });
}
function reRender(){
 document.querySelectorAll('cart-form[data-section-id]').forEach(function(form){
  if(typeof form.refresh==='function'){try{form.refresh();}catch(e){}}
 });
}
function schedule(){
 clearTimeout(timer);
 timer=setTimeout(function(){
  timer=0;
  if(document.querySelector(BAR_SELECTOR))getCart().then(syncBars).catch(function(){});
  showNotice();
 },75);
}
function codeApplied(cart,code){
 var target=code.toLowerCase();
 if((cart.cart_level_discount_applications||[]).some(function(d){return (d.title||'').toLowerCase()===target;}))return true;
 return (cart.items||[]).some(function(item){
  return (item.discounts||[]).some(function(d){return (d.title||'').toLowerCase()===target;})||
   (item.line_level_discount_allocations||[]).some(function(d){
    return ((d.discount_application&&d.discount_application.title)||'').toLowerCase()===target;
   });
 });
}
async function applyCode(btn){
 if(btn.disabled)return;
 var box=btn.closest('[data-rs-cart-discount]'),input=box&&box.querySelector('[data-rs-discount-input]');
 if(!input)return;
 var code=input.value.trim();
 if(!code){notice={type:'error',key:'Empty',code:''};showNotice();input.focus();return;}
 btn.disabled=true;btn.setAttribute('aria-busy','true');
 try{
  var res=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',
   headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})});
  if(!res.ok)throw Error('discount');
  var cart=await res.json();
  var rejected=Array.isArray(cart.discount_codes)&&cart.discount_codes.some(function(d){
   return String(d.code||'').toLowerCase()===code.toLowerCase()&&d.applicable===false;
  });
  var accepted=!rejected&&codeApplied(cart,code);
  notice={type:rejected?'error':accepted?'success':'info',key:rejected?'Invalid':accepted?'Success':'Pending',code:code};
  syncBars(cart);showNotice();reRender();
 }catch(e){notice={type:'error',key:'Error',code:code};showNotice();}
 finally{btn.disabled=false;btn.removeAttribute('aria-busy');}
}
document.addEventListener('click',function(e){
 var btn=e.target.closest('[data-rs-discount-apply]');if(btn){e.preventDefault();applyCode(btn);}
});
document.addEventListener('keydown',function(e){
 if(e.key!=='Enter'||!e.target.matches('[data-rs-discount-input]'))return;
 e.preventDefault();var box=e.target.closest('[data-rs-cart-discount]');
 var btn=box&&box.querySelector('[data-rs-discount-apply]');if(btn)applyCode(btn);
});
['on:cart:after-merge','on:cart:add','on:cart:change','on:cart-drawer:after-open'].forEach(function(name){document.addEventListener(name,schedule);});
window.addEventListener('pageshow',schedule);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',showNotice,{once:true});
else showNotice();
})();
